import { isRelativeUrl } from "./isRelativeUrl";
import { joinUrl } from "./joinUrl";
const ASSETS_ROUTE = "api/3pq-cs/v2/configuration/assets";
/**
 * Adjust with base URL it is a relative URL
 * @category Helper
 * @param assetUrl
 * @param baseUrl
 * @returns
 */
export function adjustAssetUrl(assetUrl, baseUrl) {
    if (!assetUrl) {
        return "";
    }
    if (isRelativeUrl(assetUrl)) {
        return joinUrl(baseUrl, ASSETS_ROUTE, assetUrl);
    }
    return assetUrl;
}
//# sourceMappingURL=adjustAssetUrl.js.map